import { ActionTypes } from "../constants/action-types";

/*
    Nosto Action Types with payload
*/
export const nostoPlacements = (nostoPlacements) => {
  return {
    type: ActionTypes.NOSTO_PLACEMENTS,
    payload: nostoPlacements,
  };
};
